import { AssessmentItem } from './Assessment';
import { Model, Nullable, Ordenable } from './Model';

export enum LessonPlanItemContentType {
  REGULAR = 'regular',
  EVALUATION = 'evaluation',
}

export default interface LessonPlanItem extends Model, Ordenable {
  lessonPlanId: number;
  name: string;
  time: number;
  isEvaluation: boolean;
  assessmentItem: Nullable<AssessmentItem>;
}

export type LessonPlanItemDTO = Pick<
  LessonPlanItem,
  'name' | 'time' | 'isEvaluation'
> & {
  assessmentItemId: Nullable<number>;
};
